import {
	Component, Input, Output, SimpleChanges, EventEmitter
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ComponentBase } from '../../../common';
import { SnmpMonitorEntry } from '../../../DiscoveryEngine.TS/Monitors/MonitorSettings_Snmp';


@Component({
	selector: 'custom-snmp-entry',
	templateUrl: './customsnmpentry.component.html',
	styleUrls: ['./customsnmpentry.component.scss']
})
export class CustomSnmpEntryComponent extends ComponentBase {

	@Input()
	public visible: boolean;

	@Input()
	public target: SnmpMonitorEntry;

	@Input()
	public isCreate: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onSave: EventEmitter<any>

	@Output()
	public onCancel: EventEmitter<any>;

	public settingsForm: UntypedFormGroup;

	public oid: UntypedFormControl;
	public name: UntypedFormControl;
	public category: UntypedFormControl;
	public option: UntypedFormControl;
	public expectedValue: UntypedFormControl;
	public expectedValueUseNotEqual: UntypedFormControl;
	public criticalThreshold: UntypedFormControl;
	public warningThreshold: UntypedFormControl;
	public thresholdsUseLessThan: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();

		this.visible = false;
		this.target = null;
		this.isCreate = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onSave = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();

		this.buildForm();
	}

	public get hasTarget(): boolean {
		return !!this.target;
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildForm();
	}

	public ngOnDestroy(): void {

	}

	private buildForm(): void {

		let oid = "";
		let name = "";
		let category = "";
		let option = "1";
		let expectedValue = "";
		let expectedValueUseNotEqual = false;
		let criticalThreshold = 0;
		let warningThreshold = 0;
		let thresholdsUseLessThan = false;

		if (this.hasTarget) {
			oid = this.target.Oid;
			name = this.target.Name;
			category = this.target.Category;
			option = (this.target.CollectOnly ? '1' : (this.target.UseExpectedValue ? '2' : (this.target.UseThresholds ? '3' : '1')));
			expectedValue = this.target.ExpectedValue;
			expectedValueUseNotEqual = this.target.ExpectedValue_UseNotEqual;
			criticalThreshold = this.target.CriticalThreshold;
			warningThreshold = this.target.WarningThreshold;
			thresholdsUseLessThan = this.target.Thresholds_UseLessThan;
		}

		this.oid = new UntypedFormControl(oid, Validators.required);
		this.name = new UntypedFormControl(name);
		this.category = new UntypedFormControl(category);
		this.option = new UntypedFormControl(option);
		this.expectedValue = new UntypedFormControl(expectedValue);
		this.expectedValueUseNotEqual = new UntypedFormControl(expectedValueUseNotEqual);
		this.criticalThreshold = new UntypedFormControl(criticalThreshold);
		this.warningThreshold = new UntypedFormControl(warningThreshold);
		this.thresholdsUseLessThan = new UntypedFormControl(thresholdsUseLessThan);

		this.enableDisableControls();

		this.settingsForm = this.fb.group({
			oid: this.oid,
			name: this.name,
			category: this.category,
			option: this.option,
			expectedValue: this.expectedValue,
			expectedValueUseNotEqual: this.expectedValueUseNotEqual,
			criticalThreshold: this.criticalThreshold,
			warningThreshold: this.warningThreshold,
			thresholdsUseLessThan: this.thresholdsUseLessThan,
		});
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.oid, this.isCreate);
		this.enableDisableFormControl(this.expectedValue, this.OptionEquals('2'));
		this.enableDisableFormControl(this.expectedValueUseNotEqual, this.OptionEquals('2'));
		this.enableDisableFormControl(this.criticalThreshold, this.OptionEquals('3'));
		this.enableDisableFormControl(this.warningThreshold, this.OptionEquals('3'));
		this.enableDisableFormControl(this.thresholdsUseLessThan, this.OptionEquals('3'));
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);
	}

	public onSaveClicked(): void {
		this.target.Oid = this.oid.value;
		this.target.Name = this.name.value;
		this.target.Category = this.category.value;
		this.target.CollectOnly = (this.option.value == '1');
		this.target.UseExpectedValue = (this.option.value == '2');
		this.target.ExpectedValue = this.expectedValue.value;
		this.target.ExpectedValue_UseNotEqual = this.expectedValueUseNotEqual.value;
		this.target.UseThresholds = (this.option.value == '3');
		this.target.CriticalThreshold = this.parseThresholdValue(this.criticalThreshold);
		this.target.WarningThreshold = this.parseThresholdValue(this.warningThreshold);
		this.target.Thresholds_UseLessThan = this.thresholdsUseLessThan.value;

		this.onSave.emit();
		this.hide();
	}

	private parseThresholdValue(field: UntypedFormControl): number {
		if (field.value) {
			return Number.parseFloat(field.value);
		}
		else {
			return 0;
		}
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	public isSaveEnabled(): boolean {
		return (this.settingsForm.dirty && this.settingsForm.valid);
	}

	public OptionEquals(value: string) {
		if (this.option) {
			return (this.option.value === value);
		}
		else {
			return false;
		}
	}

}
